import { useEffect, useState } from 'react';
import type { FieldSorts } from '../@types/common';
import type { LinkedRecordResult } from '../@types/linked-records-field';
import { useGetLinkedRecordsQuery } from '../redux/services/record';

const mapLinkedRecordIds = (linkedRecordIds?: Array<string | number>) => {
  return linkedRecordIds?.map((linkedRecordId) => {
    return Number(linkedRecordId);
  });
};

/**
 * A hook that fetches records of linked records fields, by recordId and fieldId and linkedRecordIds.
 * @param {number} recordId
 * @param {number} fieldId
 * @param {Array<number | string>} linkedRecordIds
 * @param {FieldSorts} sorts
 * @returns {{isFetching: boolean, linkedRecords: Array<LinkedRecordResult>}}
 */
const useFetchLinkedRecords = (
  recordId?: number,
  fieldId?: number,
  linkedRecordIds?: Array<number | string>,
  sorts?: FieldSorts
): { linkedRecords: Array<LinkedRecordResult>; isFetching: boolean } => {
  const [linkedRecords, setLinkedRecords] = useState<Array<LinkedRecordResult>>([]);

  const { data: recordData, isFetching: isRecordDataFetching } = useGetLinkedRecordsQuery(
    { recordId, fieldId, linkedRecordIds: mapLinkedRecordIds(linkedRecordIds), sorts },
    {
      skip:
        recordId === undefined ||
        fieldId === undefined ||
        linkedRecordIds === undefined ||
        linkedRecordIds.length === 0,
    }
  );

  useEffect(() => {
    if (recordData && !isRecordDataFetching) {
      setLinkedRecords(recordData);
    }
  }, [recordData, isRecordDataFetching]);

  return {
    linkedRecords,
    isFetching: isRecordDataFetching,
  };
};

export default useFetchLinkedRecords;
